// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!./global.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* App.css */
*{
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

html, body {
  overflow-x: hidden;
}

/* Video Background Styles */
.video-background {
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  overflow: hidden;
  position: relative;
  display: flex;
  flex-direction: column;
}

i.icon-site-logo-{
  font-size: 4vh !important;
}



.video-background .landing-video {
  width: 100%;
  height: 100%;
  object-fit: cover;
  position: absolute;
  left: 0;
  top: 0;
}
/* Navbar Styles */
.navbar{
  width: 100%;
  z-index: 999;
}
.navbar-toggle-icon{
  filter:invert;
}
.icon-yellow{
  color: var(--bs-text-color);
}

.dropdown-menu[data-bs-popper] {
  top: 100% !important;
  left: auto !important; 
  margin-top: var(--bs-dropdown-spacer);
  transform: none !important; 
}


.video-controls button {
  background-color: rgba(0, 0, 0, 0.596);
  color: white;
  height: 4vh;
  padding: 0 10px;
  font-weight: 600;
  cursor: pointer;
  border: none;
}

.video-controls button:hover {
  background-color: #ffffff;
  color: #000000;
}


.gap-10rem{
  gap: 10rem !important;
}
p {
  margin-top: 0 !important;
  margin-bottom: 0 !important;
}
.section-margin{
  margin: 25px 0px;
}

@media only screen and (max-width:991px){ 
  .mobile-menu {
    position: absolute;
    top: 100%;
    width: calc(100% - 32px);
    text-align: left;
    left: 50%;
    right: auto;
    transform: translateX(-50%);
    padding: 16px;
    border-radius: 8px;
  }

  .montser-lrg, .reg-montser-lrg {
    font-family: 'Montserrat-large' !important;
    font-size: 2vh !important;
    font-weight: 100 !important;
    font-style: normal !important;
  }
 

  .gap-10rem{
    gap: 6rem !important;
  }

  .text-padding {
      padding-left: 0vw;
  }
  .text-yellow {
      color: var(--bs-text-color) !important;
    }

  .aboutSectionActive .text-yellow {
    color: #EFEFEF !important;
  }


  .shadowsSectionActive .text-yellow {
    color: #EFEFEF !important;
  }
  
  .educationSectionActive .text-yellow {
    color: #EFEFEF !important;
  }
  
  
  .researchSectionActive  .text-yellow {
    color: #EFEFEF !important;
  }
  
  .aboutSectionActive  .text-yellow {
    color: #EFEFEF !important;
  }

  .tutorSectionActive .text-yellow {
    color: #EFEFEF !important;
  }

  .educationSectionActive .text-yellow {
    color: #EFEFEF !important;
  }

  .repetitionSectionActive .text-yellow {
    color: #EFEFEF !important;
  }

  .kaleidoscopeSectionActive .text-yellow {
    color: #EFEFEF !important;
  }

  .matrixSectionActive .text-yellow {
    color: #EFEFEF !important;
  }
  
  .neuroSectionActive .text-yellow {
    color: #EFEFEF !important;
  }

  .inner-container {
    flex-direction: column;
  }
}



@media only screen and (max-width:1600px){
  .vp-container {
    padding: 0 5.5vw !important;
  }

  .inner-container {
    flex-direction: column;
  }
 
}

@media only screen and (max-width:768px){

  .footer-padding {
    margin-left: 0 !important;
    padding-left: 10px !important;
  }

  .ft-1{
    font-size: 1rem !important;
  }



  .inner-container {
    flex-direction: column;
  }
  .image-container, .image-container img{
    max-width: 100%!important;
    max-height: 100% !important;
    margin: 16px 0 0 0 !important
  }
}

.inner-container {
  display: flex;
  flex-direction: row;
}

.card {
  cursor: pointer;
}
.card img:hover {
  box-shadow: 0 0 0.1rem #37678b, 0 0 0.1rem #37678b, 0 0 0.1rem #69a8d6, 0 0 0.2rem #69a8d6, 0 0 0.3rem #69a8d6 !important;
}

.custom-btn:hover {
  --bs-btn-bg: #EFEFEF;
  --bs-btn-color: #000000 ;
  color: var( #d5dec1);
}

.custom-btn{
    --bs-btn-padding-x: 0.75rem;
    --bs-btn-padding-y: 0.375rem;
    --bs-btn-font-family: ;
    --bs-btn-font-size: 1rem;
    --bs-btn-font-weight: 400;
    --bs-btn-line-height: 1.5;
    --bs-btn-color: #333333;
    --bs-btn-bg: transparent;
    --bs-btn-border-width: var(--bs-border-width);
    --bs-btn-border-color: transparent;
    --bs-btn-border-radius: var(--bs-border-radius);
    --bs-btn-hover-border-color: transparent;
    --bs-btn-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15),0 1px 1px rgba(0, 0, 0, 0.075);
    --bs-btn-disabled-opacity: 0.65;
    --bs-btn-focus-box-shadow: 0 0 0 0.25rem rgba(var(--bs-btn-focus-shadow-rgb), .5);
    display: inline-block;
    padding: var(--bs-btn-padding-y) var(--bs-btn-padding-x);
    font-family: var(--bs-btn-font-family);
    font-size: var(--bs-btn-font-size);
    font-weight: var(--bs-btn-font-weight);
    line-height: var(--bs-btn-line-height);
    color: var(--bs-btn-color);
    text-align: center;
    text-decoration: none;
    vertical-align: middle;
    cursor: pointer;
    -webkit-user-select: none;
    user-select: none;
    border: var(--bs-btn-border-width) solid var(--bs-btn-border-color);
    border-radius: var(--bs-btn-border-radius);
    background-color: var(--bs-btn-bg);
    transition: color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out;
}
.cursor-pointer{

  cursor: pointer!important;
}
.no-flex{
  flex-wrap: nowrap !important;
}

.text-dark1 {
  color: #e2eecc!important;
}

.dropdown-menu{
  padding:.5vw !important;
}

.bg-1c2933-90opa{
  background: #1c293390 !important;
}

@media screen and (max-width: 575px) {
 
  .footer-padding {
    padding-top: 5rem !important;
    padding-bottom: 5rem !important;
  }
  .ft-1{
    font-size: 1.5rem !important;
  }
  .ft-section-heading {
    font-size: 2.5vh !important;
  }
  .custom-large-heading, .montser-MediumItalic {
    font-size: 2.5vh !important;
  }
  .custom-extra-large-heading {
    font-size: 4vh !important;
  }
  .section-contaner {
    width: auto;
  }

  .section-img {
    max-width: 100% !important;
  }
  .footer-menu li {
      flex-grow: 0;
      flex-shrink: 0;
      flex-basis: calc(50% - 16px);
      width: calc(50% - 16px);
  }

  .inner-container {
    flex-direction: column;
  }
  .image-container, .image-container img{
    max-width: 100%!important;
    max-height: 100% !important;
    margin: 0 !important
  }
  .custom-extra-large-heading {
    font-family: 'Montserrat-medium' !important;
    font-size: 4.8vh !important;
    font-weight: 600 !important;
    font-style: normal !important;
}
}
@media (max-width: 768px) {
  .text-sm {
    font-size: 1.5rem;
   }
 } 
 .text-sm{
  font-family: 'Montserrat-large' !important;
 }
 
 .carousel {
  position: relative;
 }

.carousel-item {
  display: flex;
  justify-content: center; 
  align-items: center; 
  height: calc(100vh - 40px); 
  position: relative; 
  margin-top:5vw;
}

.carousel video {
  width: 75% !important;
  border-radius: 10px 10px 0px 0px;
}
.video-control-button {
  position: absolute;
  bottom: 30px; 
  left: 30px; 
  background-color: rgba(0, 0, 0, 0.5);
  color: #ffe6c8;
  border: none;
  padding: 10px 20px;
  cursor: pointer;
  font-size: 16px;
  border-radius: 5px;
}

.video-control-button:hover {
  background-color: rgba(0, 0, 0, 0.7);
}
.corousal-text{
    position: relative;
    top: 15vw;
    color: #ffe6c8;
    font-size: 2vw !important;
    margin: 3vw;
}
.carousel-caption {
  position: absolute !important;
  bottom: 1.25rem !important;
  left: -63% !important;
  z-index: 9;
  top: 85% !important;
  padding: 2.25 rem !important; 
  color: fff;
  text-align: center;
}
.carousel-caption {
  position: absolute;
  bottom: 20px;
  left: 20px;
}
.mainSectionDiv {
  text-align: center;
}
.feature-text{
  position: relative;
  left:-41.5vw !important;
  top:7vw !important
}
.next-prev-btn{
  height: 3vw !important;
  position: relative !important;
  top: 3vw !important;
}
.btn-outline-primary {
  --bs-btn-color: #EFEFEF !important;
  --bs-btn-border-color: #EFEFEF !important;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #0d6efd;
  --bs-btn-hover-border-color: #0d6efd;
  --bs-btn-focus-shadow-rgb: 13,110,253;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #0d6efd;
  --bs-btn-active-border-color: #0d6efd;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #0d6efd;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #0d6efd;
  --bs-gradient: none;

}
.container{
  margin-top: 3rem !important;
    position: relative;
    right: 3vw;
}
.job-item {
  display: flex;
  align-items: flex-start;
}

.job-content {
  flex: 1 1;
}

.job-icon {
  display: flex;
  align-items: center;
  margin-left: 10px; 
}

/* card css*/
.job-width {
  width: 100% !important;
}

.slider {
  position: relative;
  width: 100%;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
}

.slider-control {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  background-color: rgba(0, 0, 0, 0.5);
  border: none;
  color: #ffe6c8 !important;
  font-size: 2rem;
  cursor: pointer;
  z-index: 1;
}

.slider-control.prev {
  left: 10px;
}

.slider-control.next {
  right: 10px;
}

.slider-content {
  display: flex;
  transition: transform 0.5s ease-in-out;
  padding: 0 2.25%; 
  gap: 1.5rem; 
}

 .slider-item {
  height: max-content; 
  background-size: cover;
  background-position: center;
  flex: 0 0 25%; 
  position: relative;
}

.slider-overlay {
  padding: 5px;
  text-align: center;
  position: absolute;
  bottom: 0%;
  height:50% !important;
  width: 100%;
  border-radius: 1rem 1rem 0 0;
}

.slider-item:hover .slider-overlay {
  opacity: 0.95 !important;
}

.slider-item:hover img {
  transform: scale(1.01); 
}

.meet-us-btn:hover {
  background-color: #e2eecc !important;
    color: #004c4c !important;
}

.navbar-scrolling {
  background-color: black !important;
}

.svg-rotate svg{
  transform-style: preserve-3d;
  animation: rotateY 10s linear infinite;
}

.vp-logo{
  margin-left: 0.6rem;
  max-width: 50px;
  width: 100%;
  height: 100%;
  max-height: 32px;
}
.vp-logo svg{
  transform-style: preserve-3d;
  animation: rotateY 10s linear infinite;

}
.footer-padding {
  padding: 1rem; /* Default padding for all devices */
}

.footer-container {
  display: flex;
  flex-direction: column;
}

.footer-menu {
  flex-wrap: wrap; /* Allow wrapping on smaller screens */
}

/* Make sure Educator, Feature, Research align in one row */
@media (max-width: 768px) {
  .footer-menu {
    flex-direction: column; /* Stack items on small screens */
  }
  .navbar-nav{
    margin-left:1.5rem;
  }
  /* .footer-container .logo-container {
    margin-bottom: 2rem;
  } */
}
@media screen and (max-width: 575px) {
  .custom-large-heading, .montser-mdm-italic, .ft-5vh {
      font-size: 2.5vh !important;
  }
}

.media-overlay img{
  width:75% !important
}

.otherLangFontSize1_5rem{
  font-size: 1.5rem !important;
  font-family: 'Montserrat-large';
}
.otherLangFontSize1_6rem{
  font-size: 1.6rem !important;
  font-family: 'Montserrat-large';
}
.otherLangFontSize1_8rem{
  font-size: 1.8rem !important;
  font-family: 'Montserrat-large';
}
.otherLangFontSize2rem{
  font-size: 2rem !important;
  font-family: 'Montserrat-large';
}
.otherLangFontSize2_5rem{
  font-size: 2.5rem !important;
  font-family: 'Montserrat-Light-italic' !important;
  font-weight: unset !important;
  font-style: italic !important;
}
.otherLangFontSize3rem{
  font-size: 3rem !important;
  font-family: 'Montserrat-large';
}
.otherlang_custom-large-heading{
  font-size: 3.5rem !important;
  font-family: 'Montserrat-large';
}
/* @media screen and (min-width: 1200px) {
  .AddXtraMargintoAdjustContent{
    margin-left: -6rem !important;
  } 
} */
.navbar-brand {
  cursor: pointer;
  display: inline-block;  
}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAEA,YAAY;AACZ;EACE,SAAS;EACT,UAAU;EACV,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;AACpB;;AAEA,4BAA4B;AAC5B;EACE,MAAM;EACN,OAAO;EACP,WAAW;EACX,aAAa;EACb,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;AAC3B;;;;AAIA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,OAAO;EACP,MAAM;AACR;AACA,kBAAkB;AAClB;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,aAAa;AACf;AACA;EACE,2BAA2B;AAC7B;;AAEA;EACE,oBAAoB;EACpB,qBAAqB;EACrB,qCAAqC;EACrC,0BAA0B;AAC5B;;;AAGA;EACE,sCAAsC;EACtC,YAAY;EACZ,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;;AAGA;EACE,qBAAqB;AACvB;AACA;EACE,wBAAwB;EACxB,2BAA2B;AAC7B;AACA;EACE,gBAAgB;AAClB;;AAEA;EACE;IACE,kBAAkB;IAClB,SAAS;IACT,wBAAwB;IACxB,gBAAgB;IAChB,SAAS;IACT,WAAW;IACX,2BAA2B;IAC3B,aAAa;IACb,kBAAkB;EACpB;;EAEA;IACE,0CAA0C;IAC1C,yBAAyB;IACzB,2BAA2B;IAC3B,6BAA6B;EAC/B;;;EAGA;IACE,oBAAoB;EACtB;;EAEA;MACI,iBAAiB;EACrB;EACA;MACI,sCAAsC;IACxC;;EAEF;IACE,yBAAyB;EAC3B;;;EAGA;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;EAC3B;;;EAGA;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,sBAAsB;EACxB;AACF;;;;AAIA;EACE;IACE,2BAA2B;EAC7B;;EAEA;IACE,sBAAsB;EACxB;;AAEF;;AAEA;;EAEE;IACE,yBAAyB;IACzB,6BAA6B;EAC/B;;EAEA;IACE,0BAA0B;EAC5B;;;;EAIA;IACE,sBAAsB;EACxB;EACA;IACE,yBAAyB;IACzB,2BAA2B;IAC3B;EACF;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;AACA;EACE,yHAAyH;AAC3H;;AAEA;EACE,oBAAoB;EACpB,wBAAwB;EACxB,oBAAoB;AACtB;;AAEA;IACI,2BAA2B;IAC3B,4BAA4B;IAC5B,sBAAsB;IACtB,wBAAwB;IACxB,yBAAyB;IACzB,yBAAyB;IACzB,uBAAuB;IACvB,wBAAwB;IACxB,6CAA6C;IAC7C,kCAAkC;IAClC,+CAA+C;IAC/C,wCAAwC;IACxC,2FAA2F;IAC3F,+BAA+B;IAC/B,iFAAiF;IACjF,qBAAqB;IACrB,wDAAwD;IACxD,sCAAsC;IACtC,kCAAkC;IAClC,sCAAsC;IACtC,sCAAsC;IACtC,0BAA0B;IAC1B,kBAAkB;IAClB,qBAAqB;IACrB,sBAAsB;IACtB,eAAe;IACf,yBAAyB;IACzB,iBAAiB;IACjB,mEAAmE;IACnE,0CAA0C;IAC1C,kCAAkC;IAClC,8HAA8H;AAClI;AACA;;EAEE,yBAAyB;AAC3B;AACA;EACE,4BAA4B;AAC9B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;;EAEE;IACE,4BAA4B;IAC5B,+BAA+B;EACjC;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,WAAW;EACb;;EAEA;IACE,0BAA0B;EAC5B;EACA;MACI,YAA0B;MAA1B,cAA0B;MAA1B,4BAA0B;MAC1B,uBAAuB;EAC3B;;EAEA;IACE,sBAAsB;EACxB;EACA;IACE,yBAAyB;IACzB,2BAA2B;IAC3B;EACF;EACA;IACE,2CAA2C;IAC3C,2BAA2B;IAC3B,2BAA2B;IAC3B,6BAA6B;AACjC;AACA;AACA;EACE;IACE,iBAAiB;GAClB;CACF;CACA;EACC,0CAA0C;CAC3C;;CAEA;EACC,kBAAkB;CACnB;;AAED;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,0BAA0B;EAC1B,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,gCAAgC;AAClC;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,UAAU;EACV,oCAAoC;EACpC,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,oCAAoC;AACtC;AACA;IACI,kBAAkB;IAClB,SAAS;IACT,cAAc;IACd,yBAAyB;IACzB,WAAW;AACf;AACA;EACE,6BAA6B;EAC7B,0BAA0B;EAC1B,qBAAqB;EACrB,UAAU;EACV,mBAAmB;EACnB,4BAA4B;EAC5B,UAAU;EACV,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,UAAU;AACZ;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,uBAAuB;EACvB;AACF;AACA;EACE,sBAAsB;EACtB,6BAA6B;EAC7B,mBAAmB;AACrB;AACA;EACE,kCAAkC;EAClC,yCAAyC;EACzC,0BAA0B;EAC1B,0BAA0B;EAC1B,oCAAoC;EACpC,qCAAqC;EACrC,2BAA2B;EAC3B,2BAA2B;EAC3B,qCAAqC;EACrC,4DAA4D;EAC5D,gCAAgC;EAChC,iCAAiC;EACjC,uCAAuC;EACvC,mBAAmB;;AAErB;AACA;EACE,2BAA2B;IACzB,kBAAkB;IAClB,UAAU;AACd;AACA;EACE,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA,YAAY;AACZ;EACE,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,2BAA2B;EAC3B,oCAAoC;EACpC,YAAY;EACZ,yBAAyB;EACzB,eAAe;EACf,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sCAAsC;EACtC,gBAAgB;EAChB,WAAW;AACb;;CAEC;EACC,mBAAmB;EACnB,sBAAsB;EACtB,2BAA2B;EAC3B,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,UAAU;EACV,qBAAqB;EACrB,WAAW;EACX,4BAA4B;AAC9B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,oCAAoC;IAClC,yBAAyB;AAC7B;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,4BAA4B;EAC5B,sCAAsC;AACxC;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,WAAW;EACX,YAAY;EACZ,gBAAgB;AAClB;AACA;EACE,4BAA4B;EAC5B,sCAAsC;;AAExC;AACA;EACE,aAAa,EAAE,oCAAoC;AACrD;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,eAAe,EAAE,sCAAsC;AACzD;;AAEA,2DAA2D;AAC3D;EACE;IACE,sBAAsB,EAAE,iCAAiC;EAC3D;EACA;IACE,kBAAkB;EACpB;EACA;;KAEG;AACL;AACA;EACE;MACI,2BAA2B;EAC/B;AACF;;AAEA;EACE;AACF;;AAEA;EACE,4BAA4B;EAC5B,+BAA+B;AACjC;AACA;EACE,4BAA4B;EAC5B,+BAA+B;AACjC;AACA;EACE,4BAA4B;EAC5B,+BAA+B;AACjC;AACA;EACE,0BAA0B;EAC1B,+BAA+B;AACjC;AACA;EACE,4BAA4B;EAC5B,iDAAiD;EACjD,6BAA6B;EAC7B,6BAA6B;AAC/B;AACA;EACE,0BAA0B;EAC1B,+BAA+B;AACjC;AACA;EACE,4BAA4B;EAC5B,+BAA+B;AACjC;AACA;;;;GAIG;AACH;EACE,eAAe;EACf,qBAAqB;AACvB","sourcesContent":["@import '../src/global.css'; \n\n/* App.css */\n*{\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n}\n\nhtml, body {\n  overflow-x: hidden;\n}\n\n/* Video Background Styles */\n.video-background {\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100vh;\n  overflow: hidden;\n  position: relative;\n  display: flex;\n  flex-direction: column;\n}\n\ni.icon-site-logo-{\n  font-size: 4vh !important;\n}\n\n\n\n.video-background .landing-video {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  position: absolute;\n  left: 0;\n  top: 0;\n}\n/* Navbar Styles */\n.navbar{\n  width: 100%;\n  z-index: 999;\n}\n.navbar-toggle-icon{\n  filter:invert;\n}\n.icon-yellow{\n  color: var(--bs-text-color);\n}\n\n.dropdown-menu[data-bs-popper] {\n  top: 100% !important;\n  left: auto !important; \n  margin-top: var(--bs-dropdown-spacer);\n  transform: none !important; \n}\n\n\n.video-controls button {\n  background-color: rgba(0, 0, 0, 0.596);\n  color: white;\n  height: 4vh;\n  padding: 0 10px;\n  font-weight: 600;\n  cursor: pointer;\n  border: none;\n}\n\n.video-controls button:hover {\n  background-color: #ffffff;\n  color: #000000;\n}\n\n\n.gap-10rem{\n  gap: 10rem !important;\n}\np {\n  margin-top: 0 !important;\n  margin-bottom: 0 !important;\n}\n.section-margin{\n  margin: 25px 0px;\n}\n\n@media only screen and (max-width:991px){ \n  .mobile-menu {\n    position: absolute;\n    top: 100%;\n    width: calc(100% - 32px);\n    text-align: left;\n    left: 50%;\n    right: auto;\n    transform: translateX(-50%);\n    padding: 16px;\n    border-radius: 8px;\n  }\n\n  .montser-lrg, .reg-montser-lrg {\n    font-family: 'Montserrat-large' !important;\n    font-size: 2vh !important;\n    font-weight: 100 !important;\n    font-style: normal !important;\n  }\n \n\n  .gap-10rem{\n    gap: 6rem !important;\n  }\n\n  .text-padding {\n      padding-left: 0vw;\n  }\n  .text-yellow {\n      color: var(--bs-text-color) !important;\n    }\n\n  .aboutSectionActive .text-yellow {\n    color: #EFEFEF !important;\n  }\n\n\n  .shadowsSectionActive .text-yellow {\n    color: #EFEFEF !important;\n  }\n  \n  .educationSectionActive .text-yellow {\n    color: #EFEFEF !important;\n  }\n  \n  \n  .researchSectionActive  .text-yellow {\n    color: #EFEFEF !important;\n  }\n  \n  .aboutSectionActive  .text-yellow {\n    color: #EFEFEF !important;\n  }\n\n  .tutorSectionActive .text-yellow {\n    color: #EFEFEF !important;\n  }\n\n  .educationSectionActive .text-yellow {\n    color: #EFEFEF !important;\n  }\n\n  .repetitionSectionActive .text-yellow {\n    color: #EFEFEF !important;\n  }\n\n  .kaleidoscopeSectionActive .text-yellow {\n    color: #EFEFEF !important;\n  }\n\n  .matrixSectionActive .text-yellow {\n    color: #EFEFEF !important;\n  }\n  \n  .neuroSectionActive .text-yellow {\n    color: #EFEFEF !important;\n  }\n\n  .inner-container {\n    flex-direction: column;\n  }\n}\n\n\n\n@media only screen and (max-width:1600px){\n  .vp-container {\n    padding: 0 5.5vw !important;\n  }\n\n  .inner-container {\n    flex-direction: column;\n  }\n \n}\n\n@media only screen and (max-width:768px){\n\n  .footer-padding {\n    margin-left: 0 !important;\n    padding-left: 10px !important;\n  }\n\n  .ft-1{\n    font-size: 1rem !important;\n  }\n\n\n\n  .inner-container {\n    flex-direction: column;\n  }\n  .image-container, .image-container img{\n    max-width: 100%!important;\n    max-height: 100% !important;\n    margin: 16px 0 0 0 !important\n  }\n}\n\n.inner-container {\n  display: flex;\n  flex-direction: row;\n}\n\n.card {\n  cursor: pointer;\n}\n.card img:hover {\n  box-shadow: 0 0 0.1rem #37678b, 0 0 0.1rem #37678b, 0 0 0.1rem #69a8d6, 0 0 0.2rem #69a8d6, 0 0 0.3rem #69a8d6 !important;\n}\n\n.custom-btn:hover {\n  --bs-btn-bg: #EFEFEF;\n  --bs-btn-color: #000000 ;\n  color: var( #d5dec1);\n}\n\n.custom-btn{\n    --bs-btn-padding-x: 0.75rem;\n    --bs-btn-padding-y: 0.375rem;\n    --bs-btn-font-family: ;\n    --bs-btn-font-size: 1rem;\n    --bs-btn-font-weight: 400;\n    --bs-btn-line-height: 1.5;\n    --bs-btn-color: #333333;\n    --bs-btn-bg: transparent;\n    --bs-btn-border-width: var(--bs-border-width);\n    --bs-btn-border-color: transparent;\n    --bs-btn-border-radius: var(--bs-border-radius);\n    --bs-btn-hover-border-color: transparent;\n    --bs-btn-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15),0 1px 1px rgba(0, 0, 0, 0.075);\n    --bs-btn-disabled-opacity: 0.65;\n    --bs-btn-focus-box-shadow: 0 0 0 0.25rem rgba(var(--bs-btn-focus-shadow-rgb), .5);\n    display: inline-block;\n    padding: var(--bs-btn-padding-y) var(--bs-btn-padding-x);\n    font-family: var(--bs-btn-font-family);\n    font-size: var(--bs-btn-font-size);\n    font-weight: var(--bs-btn-font-weight);\n    line-height: var(--bs-btn-line-height);\n    color: var(--bs-btn-color);\n    text-align: center;\n    text-decoration: none;\n    vertical-align: middle;\n    cursor: pointer;\n    -webkit-user-select: none;\n    user-select: none;\n    border: var(--bs-btn-border-width) solid var(--bs-btn-border-color);\n    border-radius: var(--bs-btn-border-radius);\n    background-color: var(--bs-btn-bg);\n    transition: color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out;\n}\n.cursor-pointer{\n\n  cursor: pointer!important;\n}\n.no-flex{\n  flex-wrap: nowrap !important;\n}\n\n.text-dark1 {\n  color: #e2eecc!important;\n}\n\n.dropdown-menu{\n  padding:.5vw !important;\n}\n\n.bg-1c2933-90opa{\n  background: #1c293390 !important;\n}\n\n@media screen and (max-width: 575px) {\n \n  .footer-padding {\n    padding-top: 5rem !important;\n    padding-bottom: 5rem !important;\n  }\n  .ft-1{\n    font-size: 1.5rem !important;\n  }\n  .ft-section-heading {\n    font-size: 2.5vh !important;\n  }\n  .custom-large-heading, .montser-MediumItalic {\n    font-size: 2.5vh !important;\n  }\n  .custom-extra-large-heading {\n    font-size: 4vh !important;\n  }\n  .section-contaner {\n    width: auto;\n  }\n\n  .section-img {\n    max-width: 100% !important;\n  }\n  .footer-menu li {\n      flex: 0 0 calc(50% - 16px);\n      width: calc(50% - 16px);\n  }\n\n  .inner-container {\n    flex-direction: column;\n  }\n  .image-container, .image-container img{\n    max-width: 100%!important;\n    max-height: 100% !important;\n    margin: 0 !important\n  }\n  .custom-extra-large-heading {\n    font-family: 'Montserrat-medium' !important;\n    font-size: 4.8vh !important;\n    font-weight: 600 !important;\n    font-style: normal !important;\n}\n}\n@media (max-width: 768px) {\n  .text-sm {\n    font-size: 1.5rem;\n   }\n } \n .text-sm{\n  font-family: 'Montserrat-large' !important;\n }\n \n .carousel {\n  position: relative;\n }\n\n.carousel-item {\n  display: flex;\n  justify-content: center; \n  align-items: center; \n  height: calc(100vh - 40px); \n  position: relative; \n  margin-top:5vw;\n}\n\n.carousel video {\n  width: 75% !important;\n  border-radius: 10px 10px 0px 0px;\n}\n.video-control-button {\n  position: absolute;\n  bottom: 30px; \n  left: 30px; \n  background-color: rgba(0, 0, 0, 0.5);\n  color: #ffe6c8;\n  border: none;\n  padding: 10px 20px;\n  cursor: pointer;\n  font-size: 16px;\n  border-radius: 5px;\n}\n\n.video-control-button:hover {\n  background-color: rgba(0, 0, 0, 0.7);\n}\n.corousal-text{\n    position: relative;\n    top: 15vw;\n    color: #ffe6c8;\n    font-size: 2vw !important;\n    margin: 3vw;\n}\n.carousel-caption {\n  position: absolute !important;\n  bottom: 1.25rem !important;\n  left: -63% !important;\n  z-index: 9;\n  top: 85% !important;\n  padding: 2.25 rem !important; \n  color: fff;\n  text-align: center;\n}\n.carousel-caption {\n  position: absolute;\n  bottom: 20px;\n  left: 20px;\n}\n.mainSectionDiv {\n  text-align: center;\n}\n.feature-text{\n  position: relative;\n  left:-41.5vw !important;\n  top:7vw !important\n}\n.next-prev-btn{\n  height: 3vw !important;\n  position: relative !important;\n  top: 3vw !important;\n}\n.btn-outline-primary {\n  --bs-btn-color: #EFEFEF !important;\n  --bs-btn-border-color: #EFEFEF !important;\n  --bs-btn-hover-color: #fff;\n  --bs-btn-hover-bg: #0d6efd;\n  --bs-btn-hover-border-color: #0d6efd;\n  --bs-btn-focus-shadow-rgb: 13,110,253;\n  --bs-btn-active-color: #fff;\n  --bs-btn-active-bg: #0d6efd;\n  --bs-btn-active-border-color: #0d6efd;\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --bs-btn-disabled-color: #0d6efd;\n  --bs-btn-disabled-bg: transparent;\n  --bs-btn-disabled-border-color: #0d6efd;\n  --bs-gradient: none;\n\n}\n.container{\n  margin-top: 3rem !important;\n    position: relative;\n    right: 3vw;\n}\n.job-item {\n  display: flex;\n  align-items: flex-start;\n}\n\n.job-content {\n  flex: 1;\n}\n\n.job-icon {\n  display: flex;\n  align-items: center;\n  margin-left: 10px; \n}\n\n/* card css*/\n.job-width {\n  width: 100% !important;\n}\n\n.slider {\n  position: relative;\n  width: 100%;\n  overflow: hidden;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.slider-control {\n  position: absolute;\n  top: 50%;\n  transform: translateY(-50%);\n  background-color: rgba(0, 0, 0, 0.5);\n  border: none;\n  color: #ffe6c8 !important;\n  font-size: 2rem;\n  cursor: pointer;\n  z-index: 1;\n}\n\n.slider-control.prev {\n  left: 10px;\n}\n\n.slider-control.next {\n  right: 10px;\n}\n\n.slider-content {\n  display: flex;\n  transition: transform 0.5s ease-in-out;\n  padding: 0 2.25%; \n  gap: 1.5rem; \n}\n\n .slider-item {\n  height: max-content; \n  background-size: cover;\n  background-position: center;\n  flex: 0 0 25%; \n  position: relative;\n}\n\n.slider-overlay {\n  padding: 5px;\n  text-align: center;\n  position: absolute;\n  bottom: 0%;\n  height:50% !important;\n  width: 100%;\n  border-radius: 1rem 1rem 0 0;\n}\n\n.slider-item:hover .slider-overlay {\n  opacity: 0.95 !important;\n}\n\n.slider-item:hover img {\n  transform: scale(1.01); \n}\n\n.meet-us-btn:hover {\n  background-color: #e2eecc !important;\n    color: #004c4c !important;\n}\n\n.navbar-scrolling {\n  background-color: black !important;\n}\n\n.svg-rotate svg{\n  transform-style: preserve-3d;\n  animation: rotateY 10s linear infinite;\n}\n\n.vp-logo{\n  margin-left: 0.6rem;\n  max-width: 50px;\n  width: 100%;\n  height: 100%;\n  max-height: 32px;\n}\n.vp-logo svg{\n  transform-style: preserve-3d;\n  animation: rotateY 10s linear infinite;\n\n}\n.footer-padding {\n  padding: 1rem; /* Default padding for all devices */\n}\n\n.footer-container {\n  display: flex;\n  flex-direction: column;\n}\n\n.footer-menu {\n  flex-wrap: wrap; /* Allow wrapping on smaller screens */\n}\n\n/* Make sure Educator, Feature, Research align in one row */\n@media (max-width: 768px) {\n  .footer-menu {\n    flex-direction: column; /* Stack items on small screens */\n  }\n  .navbar-nav{\n    margin-left:1.5rem;\n  }\n  /* .footer-container .logo-container {\n    margin-bottom: 2rem;\n  } */\n}\n@media screen and (max-width: 575px) {\n  .custom-large-heading, .montser-mdm-italic, .ft-5vh {\n      font-size: 2.5vh !important;\n  }\n}\n\n.media-overlay img{\n  width:75% !important\n}\n\n.otherLangFontSize1_5rem{\n  font-size: 1.5rem !important;\n  font-family: 'Montserrat-large';\n}\n.otherLangFontSize1_6rem{\n  font-size: 1.6rem !important;\n  font-family: 'Montserrat-large';\n}\n.otherLangFontSize1_8rem{\n  font-size: 1.8rem !important;\n  font-family: 'Montserrat-large';\n}\n.otherLangFontSize2rem{\n  font-size: 2rem !important;\n  font-family: 'Montserrat-large';\n}\n.otherLangFontSize2_5rem{\n  font-size: 2.5rem !important;\n  font-family: 'Montserrat-Light-italic' !important;\n  font-weight: unset !important;\n  font-style: italic !important;\n}\n.otherLangFontSize3rem{\n  font-size: 3rem !important;\n  font-family: 'Montserrat-large';\n}\n.otherlang_custom-large-heading{\n  font-size: 3.5rem !important;\n  font-family: 'Montserrat-large';\n}\n/* @media screen and (min-width: 1200px) {\n  .AddXtraMargintoAdjustContent{\n    margin-left: -6rem !important;\n  } \n} */\n.navbar-brand {\n  cursor: pointer;\n  display: inline-block;  \n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
